import { type ProductizedServiceExampleProjects_productizedService$key } from '#app/__generated__/relay/ProductizedServiceExampleProjects_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { ProductizedServiceExampleProject } from './ProductizedServiceExampleProject.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    overflow-x: auto;
    /* This is a workaround so that we can add padding between the project
    cards and the overflow scrollbar without adding additional white space */
    margin-bottom: -32px;

    ${theme.mediaQueries.lg} {
      margin-bottom: -48px;
    }
  `}
`;

const PortfolioProjects = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding-bottom: 32px;

    ${theme.mediaQueries.lg} {
      padding-bottom: 48px;
    }
  `}
`;

type ProductizedServiceExampleProjectsProps = {
  readonly productizedServiceRef: ProductizedServiceExampleProjects_productizedService$key;
};

export const ProductizedServiceExampleProjects = ({
  productizedServiceRef,
}: ProductizedServiceExampleProjectsProps) => {
  const {
    portfolioProjects: { edges },
  } = useFragment<ProductizedServiceExampleProjects_productizedService$key>(
    graphql`
      fragment ProductizedServiceExampleProjects_productizedService on ProductizedService {
        portfolioProjects(first: 3) {
          edges {
            node {
              id
              ...ProductizedServiceExampleProject_portfolioProject
            }
          }
        }
      }
    `,
    productizedServiceRef,
  );

  const portfolioProjects = edges.map(({ node }) => node);

  if (portfolioProjects.length === 0) {
    return null;
  }

  return (
    <Container>
      <Text textStyle="overline">Example projects</Text>
      <PortfolioProjects>
        {portfolioProjects.map((portfolioProject) => (
          <ProductizedServiceExampleProject
            key={portfolioProject.id}
            portfolioProjectRef={portfolioProject}
          />
        ))}
      </PortfolioProjects>
    </Container>
  );
};
